[
    {
        "locale": "af-ZA",
        "title": "Afrikaans",
        "englishTitle": "Afrikaans (South Africa)",
        "llmLangName": "",
        "langCode": "af",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "af-ZA-AdriNeural",
        "azureTTSMale": "af-ZA-WillemNeural"
    },
    {
        "locale": "am-ET",
        "title": "አማርኛ",
        "englishTitle": "Amharic (Ethiopia)",
        "llmLangName": "",
        "langCode": "am",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "am-ET-MekdesNeural",
        "azureTTSMale": "am-ET-AmehaNeural"
    },
    {
        "locale": "ar-AE",
        "title": "العربية (الإمارات العربية المتحدة)",
        "englishTitle": "Arabic (United Arab Emirates)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-AE-FatimaNeural",
        "azureTTSMale": "ar-AE-HamdanNeural"
    },
    {
        "locale": "ar-BH",
        "title": "العربية (البحرين)",
        "englishTitle": "Arabic (Bahrain)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-BH-LailaNeural",
        "azureTTSMale": "ar-BH-AliNeural"
    },
    {
        "locale": "ar-DZ",
        "title": "العربية (الجزائر)",
        "englishTitle": "Arabic (Algeria)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-DZ-AminaNeural",
        "azureTTSMale": "ar-DZ-IsmaelNeural"
    },
    {
        "locale": "ar-EG",
        "title": "العربية (مصر)",
        "englishTitle": "Arabic (Egypt)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-EG-SalmaNeural",
        "azureTTSMale": "ar-EG-ShakirNeural"
    },
    {
        "locale": "ar-IQ",
        "title": "العربية (العراق)",
        "englishTitle": "Arabic (Iraq)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-IQ-RanaNeural",
        "azureTTSMale": "ar-IQ-BasselNeural"
    },
    {
        "locale": "ar-JO",
        "title": "العربية (الأردن)",
        "englishTitle": "Arabic (Jordan)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-JO-SanaNeural",
        "azureTTSMale": "ar-JO-TaimNeural"
    },
    {
        "locale": "ar-KW",
        "title": "العربية (الكويت)",
        "englishTitle": "Arabic (Kuwait)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-KW-NouraNeural",
        "azureTTSMale": "ar-KW-FahedNeural"
    },
    {
        "locale": "ar-LB",
        "title": "العربية (لبنان)",
        "englishTitle": "Arabic (Lebanon)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-LB-LaylaNeural",
        "azureTTSMale": "ar-LB-RamiNeural"
    },
    {
        "locale": "ar-LY",
        "title": "العربية (ليبيا)",
        "englishTitle": "Arabic (Libya)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-LY-ImanNeural",
        "azureTTSMale": "ar-LY-OmarNeural"
    },
    {
        "locale": "ar-MA",
        "title": "العربية (المغرب)",
        "englishTitle": "Arabic (Morocco)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-MA-MounaNeural",
        "azureTTSMale": "ar-MA-JamalNeural"
    },
    {
        "locale": "ar-OM",
        "title": "العربية (عمان)",
        "englishTitle": "Arabic (Oman)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-OM-AyshaNeural",
        "azureTTSMale": "ar-OM-AbdullahNeural"
    },
    {
        "locale": "ar-QA",
        "title": "العربية (قطر)",
        "englishTitle": "Arabic (Qatar)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-QA-AmalNeural",
        "azureTTSMale": "ar-QA-MoazNeural"
    },
    {
        "locale": "ar-SA",
        "title": "العربية (المملكة العربية السعودية)",
        "englishTitle": "Arabic (Saudi Arabia)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-SA-ZariyahNeural",
        "azureTTSMale": "ar-SA-HamedNeural"
    },
    {
        "locale": "ar-SY",
        "title": "العربية (سوريا)",
        "englishTitle": "Arabic (Syria)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-SY-AmanyNeural",
        "azureTTSMale": "ar-SY-LaithNeural"
    },
    {
        "locale": "ar-TN",
        "title": "العربية (تونس)",
        "englishTitle": "Arabic (Tunisia)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-TN-ReemNeural",
        "azureTTSMale": "ar-TN-HediNeural"
    },
    {
        "locale": "ar-YE",
        "title": "العربية (اليمن)",
        "englishTitle": "Arabic (Yemen)",
        "llmLangName": "",
        "langCode": "ar",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ar-YE-MaryamNeural",
        "azureTTSMale": "ar-YE-SalehNeural"
    },
    {
        "locale": "az-AZ",
        "title": "Azərbaycan",
        "englishTitle": "Azerbaijani (Latin, Azerbaijan)",
        "llmLangName": "",
        "langCode": "az",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "az-AZ-BanuNeural",
        "azureTTSMale": "az-AZ-BabekNeural"
    },
    {
        "locale": "bg-BG",
        "title": "български",
        "englishTitle": "Bulgarian (Bulgaria)",
        "llmLangName": "",
        "langCode": "bg",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "bg-BG-KalinaNeural",
        "azureTTSMale": "bg-BG-BorislavNeural"
    },
    {
        "locale": "bn-BD",
        "title": "বাংলা",
        "englishTitle": "Bengali (Bangladesh)",
        "llmLangName": "",
        "langCode": "bn",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "bn-IN",
        "title": "বাংলা",
        "englishTitle": "Bengali (India)",
        "llmLangName": "",
        "langCode": "bn",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "bn-IN-TanishaaNeural",
        "azureTTSMale": "bn-IN-BashkarNeural"
    },
    {
        "locale": "bs-BA",
        "title": "Bosanski",
        "englishTitle": "Bosnian (Bosnia and Herzegovina)",
        "llmLangName": "",
        "langCode": "bs",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "bs-BA-VesnaNeural",
        "azureTTSMale": "bs-BA-GoranNeural"
    },
    {
        "locale": "ca-ES",
        "title": "Català",
        "englishTitle": "Catalan",
        "llmLangName": "",
        "langCode": "ca",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ca-ES-JoanaNeural",
        "azureTTSMale": "ca-ES-EnricNeural"
    },
    {
        "locale": "cs-CZ",
        "title": "Čeština",
        "englishTitle": "Czech (Czechia)",
        "llmLangName": "",
        "langCode": "cs",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "cs-CZ-VlastaNeural",
        "azureTTSMale": "cs-CZ-AntoninNeural"
    },
    {
        "locale": "cy-GB",
        "title": "Cymraeg",
        "englishTitle": "Welsh (United Kingdom)",
        "llmLangName": "",
        "langCode": "cy",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "cy-GB-NiaNeural",
        "azureTTSMale": "cy-GB-AledNeural"
    },
    {
        "locale": "da-DK",
        "title": "Dansk",
        "englishTitle": "Danish (Denmark)",
        "llmLangName": "",
        "langCode": "da",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "da-DK-ChristelNeural",
        "azureTTSMale": "da-DK-JeppeNeural"
    },
    {
        "locale": "de-AT",
        "title": "Deutsch (Österreich)",
        "englishTitle": "German (Austria)",
        "llmLangName": "",
        "langCode": "de",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "de-AT-IngridNeural",
        "azureTTSMale": "de-AT-JonasNeural"
    },
    {
        "locale": "de-CH",
        "title": "Deutsch (Schweiz)",
        "englishTitle": "German (Switzerland)",
        "llmLangName": "",
        "langCode": "de",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "de-CH-LeniNeural",
        "azureTTSMale": "de-CH-JanNeural"
    },
    {
        "locale": "de-DE",
        "title": "Deutsch (Deutschland)",
        "englishTitle": "German (Germany)",
        "llmLangName": "",
        "langCode": "de",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "de-DE-AmalaNeural",
        "azureTTSMale": "de-DE-BerndNeural"
    },
    {
        "locale": "el-GR",
        "title": "Ελληνικά",
        "englishTitle": "Greek (Greece)",
        "llmLangName": "",
        "langCode": "el",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "el-GR-AthinaNeural",
        "azureTTSMale": "el-GR-NestorasNeural"
    },
    {
        "locale": "en-AU",
        "title": "English (Australia)",
        "englishTitle": "English (Australia)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-AU-NatashaNeural",
        "azureTTSMale": "en-AU-WilliamNeural"
    },
    {
        "locale": "en-CA",
        "title": "English (Canada)",
        "englishTitle": "English (Canada)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-CA-ClaraNeural",
        "azureTTSMale": "en-CA-LiamNeural"
    },
    {
        "locale": "en-GB",
        "title": "English (UK)",
        "englishTitle": "English (United Kingdom)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-GB-SoniaNeural",
        "azureTTSMale": "en-GB-RyanNeural"
    },
    {
        "locale": "en-GH",
        "title": "English (Ghana)",
        "englishTitle": "English (Ghana)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "en-HK",
        "title": "English (HK)",
        "englishTitle": "English (Hong Kong SAR)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-HK-YanNeural",
        "azureTTSMale": "en-HK-SamNeural"
    },
    {
        "locale": "en-IE",
        "title": "English (Ireland)",
        "englishTitle": "English (Ireland)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-IE-EmilyNeural",
        "azureTTSMale": "en-IE-ConnorNeural"
    },
    {
        "locale": "en-IN",
        "title": "English (India)",
        "englishTitle": "English (India)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-IN-NeerjaNeural",
        "azureTTSMale": "en-IN-PrabhatNeural"
    },
    {
        "locale": "en-KE",
        "title": "English (Kenya)",
        "englishTitle": "English (Kenya)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-KE-AsiliaNeural",
        "azureTTSMale": "en-KE-ChilembaNeural"
    },
    {
        "locale": "en-NG",
        "title": "English (Nigeria)",
        "englishTitle": "English (Nigeria)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-NG-EzinneNeural",
        "azureTTSMale": "en-NG-AbeoNeural"
    },
    {
        "locale": "en-NZ",
        "title": "English (New Zealand)",
        "englishTitle": "English (New Zealand)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-NZ-MollyNeural",
        "azureTTSMale": "en-NZ-MitchellNeural"
    },
    {
        "locale": "en-PH",
        "title": "English (Philippines)",
        "englishTitle": "English (Philippines)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-PH-RosaNeural",
        "azureTTSMale": "en-PH-JamesNeural"
    },
    {
        "locale": "en-SG",
        "title": "English (Singapore)",
        "englishTitle": "English (Singapore)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-SG-LunaNeural",
        "azureTTSMale": "en-SG-WayneNeural"
    },
    {
        "locale": "en-TZ",
        "title": "English (Tanzania)",
        "englishTitle": "English (Tanzania)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-TZ-ImaniNeural",
        "azureTTSMale": "en-TZ-ElimuNeural"
    },
    {
        "locale": "en-US",
        "title": "English (US)",
        "englishTitle": "English (United States)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-US-JennyNeural",
        "azureTTSMale": "en-US-GuyNeural"
    },
    {
        "locale": "en-ZA",
        "title": "English (South Africa)",
        "englishTitle": "English (South Africa)",
        "llmLangName": "",
        "langCode": "en",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "en-ZA-LeahNeural",
        "azureTTSMale": "en-ZA-LukeNeural"
    },
    {
        "locale": "es-AR",
        "title": "Español (Argentina)",
        "englishTitle": "Spanish (Argentina)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-AR-ElenaNeural",
        "azureTTSMale": "es-AR-TomasNeural"
    },
    {
        "locale": "es-BO",
        "title": "Español (Bolivia)",
        "englishTitle": "Spanish (Bolivia)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-BO-SofiaNeural",
        "azureTTSMale": "es-BO-MarceloNeural"
    },
    {
        "locale": "es-CL",
        "title": "Español (Chile)",
        "englishTitle": "Spanish (Chile)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-CL-CatalinaNeural",
        "azureTTSMale": "es-CL-LorenzoNeural"
    },
    {
        "locale": "es-CO",
        "title": "Español (Colombia)",
        "englishTitle": "Spanish (Colombia)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-CO-SalomeNeural",
        "azureTTSMale": "es-CO-GonzaloNeural"
    },
    {
        "locale": "es-CR",
        "title": "Español (Costa Rica)",
        "englishTitle": "Spanish (Costa Rica)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-CR-MariaNeural",
        "azureTTSMale": "es-CR-JuanNeural"
    },
    {
        "locale": "es-CU",
        "title": "Español (Cuba)",
        "englishTitle": "Spanish (Cuba)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-CU-BelkysNeural",
        "azureTTSMale": "es-CU-ManuelNeural"
    },
    {
        "locale": "es-DO",
        "title": "Español (República Dominicana)",
        "englishTitle": "Spanish (Dominican Republic)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-DO-RamonaNeural",
        "azureTTSMale": "es-DO-EmilioNeural"
    },
    {
        "locale": "es-EC",
        "title": "Español (Ecuador)",
        "englishTitle": "Spanish (Ecuador)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-EC-AndreaNeural",
        "azureTTSMale": "es-EC-LuisNeural"
    },
    {
        "locale": "es-ES",
        "title": "Español (España)",
        "englishTitle": "Spanish (Spain)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-ES-ElviraNeural",
        "azureTTSMale": "es-ES-AlvaroNeural"
    },
    {
        "locale": "es-GQ",
        "title": "Español (Guinea Ecuatorial)",
        "englishTitle": "Spanish (Equatorial Guinea)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-GQ-TeresaNeural",
        "azureTTSMale": "es-GQ-JavierNeural"
    },
    {
        "locale": "es-GT",
        "title": "Español (Guatemala)",
        "englishTitle": "Spanish (Guatemala)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-GT-MartaNeural",
        "azureTTSMale": "es-GT-AndresNeural"
    },
    {
        "locale": "es-HN",
        "title": "Español (Honduras)",
        "englishTitle": "Spanish (Honduras)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-HN-KarlaNeural",
        "azureTTSMale": "es-HN-CarlosNeural"
    },
    {
        "locale": "es-MX",
        "title": "Español (México)",
        "englishTitle": "Spanish (Mexico)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-MX-DaliaNeural",
        "azureTTSMale": "es-MX-JorgeNeural"
    },
    {
        "locale": "es-NI",
        "title": "Español (Nicaragua)",
        "englishTitle": "Spanish (Nicaragua)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-NI-YolandaNeural",
        "azureTTSMale": "es-NI-FedericoNeural"
    },
    {
        "locale": "es-PA",
        "title": "Español (Panamá)",
        "englishTitle": "Spanish (Panama)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-PA-MargaritaNeural",
        "azureTTSMale": "es-PA-RobertoNeural"
    },
    {
        "locale": "es-PE",
        "title": "Español (Perú)",
        "englishTitle": "Spanish (Peru)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-PE-CamilaNeural",
        "azureTTSMale": "es-PE-AlexNeural"
    },
    {
        "locale": "es-PR",
        "title": "Español (Puerto Rico)",
        "englishTitle": "Spanish (Puerto Rico)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-PR-KarinaNeural",
        "azureTTSMale": "es-PR-VictorNeural"
    },
    {
        "locale": "es-PY",
        "title": "Español (Paraguay)",
        "englishTitle": "Spanish (Paraguay)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-PY-TaniaNeural",
        "azureTTSMale": "es-PY-MarioNeural"
    },
    {
        "locale": "es-SV",
        "title": "Español (El Salvador)",
        "englishTitle": "Spanish (El Salvador)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-SV-LorenaNeural",
        "azureTTSMale": "es-SV-RodrigoNeural"
    },
    {
        "locale": "es-US",
        "title": "Español (Estados Unidos)",
        "englishTitle": "Spanish (United States)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-US-PalomaNeural",
        "azureTTSMale": "es-US-AlonsoNeural"
    },
    {
        "locale": "es-UY",
        "title": "Español (Uruguay)",
        "englishTitle": "Spanish (Uruguay)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-UY-ValentinaNeural",
        "azureTTSMale": "es-UY-MateoNeural"
    },
    {
        "locale": "es-VE",
        "title": "Español (Venezuela)",
        "englishTitle": "Spanish (Venezuela)",
        "llmLangName": "",
        "langCode": "es",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "es-VE-PaolaNeural",
        "azureTTSMale": "es-VE-SebastianNeural"
    },
    {
        "locale": "et-EE",
        "title": "Eesti",
        "englishTitle": "Estonian (Estonia)",
        "llmLangName": "",
        "langCode": "et",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "et-EE-AnuNeural",
        "azureTTSMale": "et-EE-KertNeural"
    },
    {
        "locale": "eu-ES",
        "title": "Euskara",
        "englishTitle": "Basque",
        "llmLangName": "",
        "langCode": "eu",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "eu-ES-AinhoaNeural",
        "azureTTSMale": "eu-ES-AnderNeural"
    },
    {
        "locale": "fa-IR",
        "title": "فارسی",
        "englishTitle": "Persian (Iran)",
        "llmLangName": "",
        "langCode": "fa",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "fa-IR-DilaraNeural",
        "azureTTSMale": "fa-IR-FaridNeural"
    },
    {
        "locale": "fa-AF",
        "title": "دری",
        "englishTitle": "Persian (Afghan Persian)",
        "llmLangName": "",
        "langCode": "fa",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": false,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": false,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "fi-FI",
        "title": "Suomi",
        "englishTitle": "Finnish (Finland)",
        "llmLangName": "",
        "langCode": "fi",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "fi-FI-SelmaNeural",
        "azureTTSMale": "fi-FI-HarriNeural"
    },
    {
        "locale": "fil-PH",
        "title": "Filipino (Pilipinas)",
        "englishTitle": "Filipino (Philippines)",
        "llmLangName": "",
        "langCode": "fil",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "fil-PH-BlessicaNeural",
        "azureTTSMale": "fil-PH-AngeloNeural"
    },
    {
        "locale": "fr-BE",
        "title": "Français (Belgique)",
        "englishTitle": "French (Belgium)",
        "llmLangName": "",
        "langCode": "fr",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "fr-BE-CharlineNeural",
        "azureTTSMale": "fr-BE-GerardNeural"
    },
    {
        "locale": "fr-CA",
        "title": "Français (Canada)",
        "englishTitle": "French (Canada)",
        "llmLangName": "",
        "langCode": "fr",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "fr-CA-SylvieNeural",
        "azureTTSMale": "fr-CA-JeanNeural"
    },
    {
        "locale": "fr-CH",
        "title": "Français (Suisse)",
        "englishTitle": "French (Switzerland)",
        "llmLangName": "",
        "langCode": "fr",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "fr-CH-ArianeNeural",
        "azureTTSMale": "fr-CH-FabriceNeural"
    },
    {
        "locale": "fr-FR",
        "title": "Français (France)",
        "englishTitle": "French (France)",
        "llmLangName": "",
        "langCode": "fr",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "fr-FR-DeniseNeural",
        "azureTTSMale": "fr-FR-HenriNeural"
    },
    {
        "locale": "ga-IE",
        "title": "Gaeilge",
        "englishTitle": "Irish (Ireland)",
        "llmLangName": "",
        "langCode": "ga",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ga-IE-OrlaNeural",
        "azureTTSMale": "ga-IE-ColmNeural"
    },
    {
        "locale": "gl-ES",
        "title": "Galego",
        "englishTitle": "Galician",
        "llmLangName": "",
        "langCode": "gl",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "gl-ES-SabelaNeural",
        "azureTTSMale": "gl-ES-RoiNeural"
    },
    {
        "locale": "gu-IN",
        "title": "ગુજરાતી",
        "englishTitle": "Gujarati (India)",
        "llmLangName": "",
        "langCode": "gu",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "gu-IN-DhwaniNeural",
        "azureTTSMale": "gu-IN-NiranjanNeural"
    },
    {
        "locale": "he-IL",
        "title": "עִבְרִית",
        "englishTitle": "Hebrew (Israel)",
        "llmLangName": "",
        "langCode": "he",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "he-IL-HilaNeural",
        "azureTTSMale": "he-IL-AvriNeural"
    },
    {
        "locale": "hi-IN",
        "title": "भारतीय भाषा",
        "englishTitle": "Hindi (India)",
        "llmLangName": "",
        "langCode": "hi",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "hi-IN-SwaraNeural",
        "azureTTSMale": "hi-IN-MadhurNeural"
    },
    {
        "locale": "hr-HR",
        "title": "Hrvatski",
        "englishTitle": "Croatian (Croatia)",
        "llmLangName": "",
        "langCode": "hr",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "hr-HR-GabrijelaNeural",
        "azureTTSMale": "hr-HR-SreckoNeural"
    },
    {
        "locale": "ht-HT",
        "title": "Kreyòl Ayisyen",
        "englishTitle": "Haitian Creole",
        "llmLangName": "",
        "langCode": "ht",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": false,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": false,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "hu-HU",
        "title": "Magyar",
        "englishTitle": "Hungarian (Hungary)",
        "llmLangName": "",
        "langCode": "hu",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "hu-HU-NoemiNeural",
        "azureTTSMale": "hu-HU-TamasNeural"
    },
    {
        "locale": "hy-AM",
        "title": "հայերեն",
        "englishTitle": "Armenian (Armenia)",
        "llmLangName": "",
        "langCode": "hy",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "hy-AM-AnahitNeural",
        "azureTTSMale": "hy-AM-HaykNeural"
    },
    {
        "locale": "id-ID",
        "title": "Bahasa Indonesia",
        "englishTitle": "Indonesian (Indonesia)",
        "llmLangName": "",
        "langCode": "id",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "id-ID-GadisNeural",
        "azureTTSMale": "id-ID-ArdiNeural"
    },
    {
        "locale": "is-IS",
        "title": "íslenska",
        "englishTitle": "Icelandic (Iceland)",
        "llmLangName": "",
        "langCode": "is",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "is-IS-GudrunNeural",
        "azureTTSMale": "is-IS-GunnarNeural"
    },
    {
        "locale": "it-CH",
        "title": "Italiano (Svizzera)",
        "englishTitle": "Italian (Switzerland)",
        "llmLangName": "",
        "langCode": "it",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "it-IT",
        "title": "Italiano",
        "englishTitle": "Italian (Italy)",
        "llmLangName": "",
        "langCode": "it",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "it-IT-ElsaNeural",
        "azureTTSMale": "it-IT-DiegoNeural"
    },
    {
        "locale": "ja-JP",
        "title": "日本語",
        "englishTitle": "Japanese (Japan)",
        "llmLangName": "",
        "langCode": "ja",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": false,
        "azureTTSFemale": "ja-JP-NanamiNeural",
        "azureTTSMale": "ja-JP-KeitaNeural"
    },
    {
        "locale": "jv-ID",
        "title": "Basa Jawa",
        "englishTitle": "Javanese (Latin, Indonesia)",
        "llmLangName": "",
        "langCode": "jv",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "jv-ID-SitiNeural",
        "azureTTSMale": "jv-ID-DimasNeural"
    },
    {
        "locale": "ka-GE",
        "title": "ქართული",
        "englishTitle": "Georgian (Georgia)",
        "llmLangName": "",
        "langCode": "ka",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ka-GE-EkaNeural",
        "azureTTSMale": "ka-GE-GiorgiNeural"
    },
    {
        "locale": "kk-KZ",
        "title": "Қазақ тілі",
        "englishTitle": "Kazakh (Kazakhstan)",
        "llmLangName": "",
        "langCode": "kk",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "kk-KZ-AigulNeural",
        "azureTTSMale": "kk-KZ-DauletNeural"
    },
    {
        "locale": "km-KH",
        "title": "ភាសាខ្មែរ",
        "englishTitle": "Khmer (Cambodia)",
        "llmLangName": "",
        "langCode": "km",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "km-KH-SreymomNeural",
        "azureTTSMale": "km-KH-PisethNeural"
    },
    {
        "locale": "kn-IN",
        "title": "ಕನ್ನಡ",
        "englishTitle": "Kannada (India)",
        "llmLangName": "",
        "langCode": "kn",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "kn-IN-SapnaNeural",
        "azureTTSMale": "kn-IN-GaganNeural"
    },
    {
        "locale": "ko-KR",
        "title": "한국어",
        "englishTitle": "Korean (Korea)",
        "llmLangName": "",
        "langCode": "ko",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": false,
        "azureTTSFemale": "ko-KR-SunHiNeural",
        "azureTTSMale": "ko-KR-InJoonNeural"
    },
    {
        "locale": "lo-LA",
        "title": "ພາສາລາວ",
        "englishTitle": "Lao (Laos)",
        "llmLangName": "",
        "langCode": "lo",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "lo-LA-KeomanyNeural",
        "azureTTSMale": "lo-LA-ChanthavongNeural"
    },
    {
        "locale": "lt-LT",
        "title": "Lietuvių kalba (Lietuva)",
        "englishTitle": "Lithuanian (Lithuania)",
        "llmLangName": "",
        "langCode": "lt",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "lt-LT-OnaNeural",
        "azureTTSMale": "lt-LT-LeonasNeural"
    },
    {
        "locale": "lv-LV",
        "title": "Latviešu",
        "englishTitle": "Latvian (Latvia)",
        "llmLangName": "",
        "langCode": "lv",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "lv-LV-EveritaNeural",
        "azureTTSMale": "lv-LV-NilsNeural"
    },
    {
        "locale": "mk-MK",
        "title": "Македонски",
        "englishTitle": "Macedonian (North Macedonia)",
        "llmLangName": "",
        "langCode": "mk",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "mk-MK-MarijaNeural",
        "azureTTSMale": "mk-MK-AleksandarNeural"
    },
    {
        "locale": "ml-IN",
        "title": "മലയാളം",
        "englishTitle": "Malayalam (India)",
        "llmLangName": "",
        "langCode": "ml",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ml-IN-SobhanaNeural",
        "azureTTSMale": "ml-IN-MidhunNeural"
    },
    {
        "locale": "mn-MN",
        "title": "Монгол хэл",
        "englishTitle": "Mongolian (Mongolia)",
        "llmLangName": "",
        "langCode": "mn-Mong",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "mn-MN-YesuiNeural",
        "azureTTSMale": "mn-MN-BataaNeural"
    },
    {
        "locale": "mr-IN",
        "title": "मराठी",
        "englishTitle": "Marathi (India)",
        "llmLangName": "",
        "langCode": "mr",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "mr-IN-AarohiNeural",
        "azureTTSMale": "mr-IN-ManoharNeural"
    },
    {
        "locale": "ms-MY",
        "title": "Bahasa Melayu",
        "englishTitle": "Malay (Malaysia)",
        "llmLangName": "",
        "langCode": "ms",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ms-MY-YasminNeural",
        "azureTTSMale": "ms-MY-OsmanNeural"
    },
    {
        "locale": "mt-MT",
        "title": "Malti",
        "englishTitle": "Maltese (Malta)",
        "llmLangName": "",
        "langCode": "mt",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "mt-MT-GraceNeural",
        "azureTTSMale": "mt-MT-JosephNeural"
    },
    {
        "locale": "my-MM",
        "title": "မြန်မာဘာသာ",
        "englishTitle": "Burmese (Myanmar)",
        "llmLangName": "",
        "langCode": "my",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "my-MM-NilarNeural",
        "azureTTSMale": "my-MM-ThihaNeural"
    },
    {
        "locale": "nb-NO",
        "title": "Báhkovuođđu giella",
        "englishTitle": "Norwegian Bokmål (Norway)",
        "llmLangName": "",
        "langCode": "nb",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "nb-NO-PernilleNeural",
        "azureTTSMale": "nb-NO-FinnNeural"
    },
    {
        "locale": "ne-NP",
        "title": "नेपाली",
        "englishTitle": "Nepali (Nepal)",
        "llmLangName": "",
        "langCode": "ne",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ne-NP-HemkalaNeural",
        "azureTTSMale": "ne-NP-SagarNeural"
    },
    {
        "locale": "nl-BE",
        "title": "Nederlands (België)",
        "englishTitle": "Dutch (Belgium)",
        "llmLangName": "",
        "langCode": "nl",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "nl-BE-DenaNeural",
        "azureTTSMale": "nl-BE-ArnaudNeural"
    },
    {
        "locale": "nl-NL",
        "title": "Nederlands (Nederlands)",
        "englishTitle": "Dutch (Netherlands)",
        "llmLangName": "",
        "langCode": "nl",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "nl-NL-FennaNeural",
        "azureTTSMale": "nl-NL-MaartenNeural"
    },
    {
        "locale": "pa-IN",
        "title": "ਪੰਜਾਬੀ (ਭਾਰਤ)",
        "englishTitle": "Punjabi (India)",
        "llmLangName": "",
        "langCode": "pa-Guru",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "pa-IN-VaaniNeural",
        "azureTTSMale": "pa-IN-OjasNeural"
    },
    {
        "locale": "pl-PL",
        "title": "Polski",
        "englishTitle": "Polish (Poland)",
        "llmLangName": "",
        "langCode": "pl",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "pl-PL-AgnieszkaNeural",
        "azureTTSMale": "pl-PL-MarekNeural"
    },
    {
        "locale": "ps-AF",
        "title": "پښتو",
        "englishTitle": "Pashto (Afghanistan)",
        "llmLangName": "",
        "langCode": "ps",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ps-AF-LatifaNeural",
        "azureTTSMale": "ps-AF-GulNawazNeural"
    },
    {
        "locale": "pt-BR",
        "title": "Português (Brasil)",
        "englishTitle": "Portuguese (Brazil)",
        "llmLangName": "",
        "langCode": "pt",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "pt-BR-FranciscaNeural",
        "azureTTSMale": "pt-BR-AntonioNeural"
    },
    {
        "locale": "pt-PT",
        "title": "Português (Portugal)",
        "englishTitle": "Portuguese (Portugal)",
        "llmLangName": "",
        "langCode": "pt",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "pt-PT-RaquelNeural",
        "azureTTSMale": "pt-PT-DuarteNeural"
    },
    {
        "locale": "ro-RO",
        "title": "Românǎ",
        "englishTitle": "Romanian (Romania)",
        "llmLangName": "",
        "langCode": "ro",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ro-RO-AlinaNeural",
        "azureTTSMale": "ro-RO-EmilNeural"
    },
    {
        "locale": "ru-RU",
        "title": "Русский",
        "englishTitle": "Russian (Russia)",
        "llmLangName": "",
        "langCode": "ru",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ru-RU-SvetlanaNeural",
        "azureTTSMale": "ru-RU-DmitryNeural"
    },
    {
        "locale": "si-LK",
        "title": "සිංහල",
        "englishTitle": "Sinhala (Sri Lanka)",
        "llmLangName": "",
        "langCode": "si",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "si-LK-ThiliniNeural",
        "azureTTSMale": "si-LK-SameeraNeural"
    },
    {
        "locale": "sk-SK",
        "title": "Slovenčina",
        "englishTitle": "Slovak (Slovakia)",
        "llmLangName": "",
        "langCode": "sk",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "sk-SK-ViktoriaNeural",
        "azureTTSMale": "sk-SK-LukasNeural"
    },
    {
        "locale": "sl-SI",
        "title": "Slovenščina",
        "englishTitle": "Slovenian (Slovenia)",
        "llmLangName": "",
        "langCode": "sl",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "sl-SI-PetraNeural",
        "azureTTSMale": "sl-SI-RokNeural"
    },
    {
        "locale": "so-SO",
        "title": "Soomaali (Soomaaliya)",
        "englishTitle": "Somali (Somalia)",
        "llmLangName": "",
        "langCode": "so",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "so-SO-UbaxNeural",
        "azureTTSMale": "so-SO-MuuseNeural"
    },
    {
        "locale": "sq-AL",
        "title": "Shqip (Shqipëri)",
        "englishTitle": "Albanian (Albania)",
        "llmLangName": "",
        "langCode": "sq",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "sq-AL-AnilaNeural",
        "azureTTSMale": "sq-AL-IlirNeural"
    },
    {
        "locale": "sr-RS",
        "title": "Српски",
        "englishTitle": "Serbian (Cyrillic, Serbia)",
        "llmLangName": "",
        "langCode": "sr",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "sr-RS-SophieNeural",
        "azureTTSMale": "sr-RS-NicholasNeural"
    },
    {
        "locale": "sv-SE",
        "title": "Svenska",
        "englishTitle": "Swedish (Sweden)",
        "llmLangName": "",
        "langCode": "sv",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "sv-SE-SofieNeural",
        "azureTTSMale": "sv-SE-MattiasNeural"
    },
    {
        "locale": "sw-KE",
        "title": "Kiswahili (Kenya)",
        "englishTitle": "Swahili (Kenya)",
        "llmLangName": "",
        "langCode": "sw",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "sw-KE-ZuriNeural",
        "azureTTSMale": "sw-KE-RafikiNeural"
    },
    {
        "locale": "sw-TZ",
        "title": "Kiswahili (Tanzania)",
        "englishTitle": "Swahili (Tanzania)",
        "llmLangName": "",
        "langCode": "sw",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "sw-TZ-RehemaNeural",
        "azureTTSMale": "sw-TZ-DaudiNeural"
    },
    {
        "locale": "sw-UG",
        "title": "Kiswahili (Uganda)",
        "englishTitle": "Swahili (Uganda)",
        "llmLangName": "",
        "langCode": "sw",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": false,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": false,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "sw-CD",
        "title": "Kiswahili (Jamhuri ya Kidemokrasia ya Kongo)",
        "englishTitle": "Swahili (Democratic Republic of the Congo)",
        "llmLangName": "",
        "langCode": "sw",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": false,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": false,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "ta-IN",
        "title": "தமிழ்",
        "englishTitle": "Tamil (India)",
        "llmLangName": "",
        "langCode": "ta",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ta-IN-PallaviNeural",
        "azureTTSMale": "ta-IN-ValluvarNeural"
    },
    {
        "locale": "ta-LK",
        "title": "தமிழ்",
        "englishTitle": "Tamil (Sri Lanka)",
        "llmLangName": "",
        "langCode": "ta",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "ta-MY",
        "title": "தமிழ்",
        "englishTitle": "Tamil (Malaysia)",
        "llmLangName": "",
        "langCode": "ta",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "ta-SG",
        "title": "தமிழ்",
        "englishTitle": "Tamil (Singapore)",
        "llmLangName": "",
        "langCode": "ta",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "te-IN",
        "title": "தேசிய மொழி",
        "englishTitle": "Telugu (India)",
        "llmLangName": "",
        "langCode": "te",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "te-IN-ShrutiNeural",
        "azureTTSMale": "te-IN-MohanNeural"
    },
    {
        "locale": "th-TH",
        "title": "ภาษาไทย",
        "englishTitle": "Thai (Thailand)",
        "llmLangName": "",
        "langCode": "th",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "th-TH-PremwadeeNeural",
        "azureTTSMale": "th-TH-NiwatNeural"
    },
    {
        "locale": "tr-TR",
        "title": "Türkçe",
        "englishTitle": "Turkish (Türkiye)",
        "llmLangName": "",
        "langCode": "tr",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "tr-TR-EmelNeural",
        "azureTTSMale": "tr-TR-AhmetNeural"
    },
    {
        "locale": "uk-UA",
        "title": "Українська",
        "englishTitle": "Ukrainian (Ukraine)",
        "llmLangName": "",
        "langCode": "uk",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "uk-UA-PolinaNeural",
        "azureTTSMale": "uk-UA-OstapNeural"
    },
    {
        "locale": "ur-IN",
        "title": "اردو",
        "englishTitle": "Urdu (India)",
        "llmLangName": "",
        "langCode": "ur",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "ur-IN-GulNeural",
        "azureTTSMale": "ur-IN-SalmanNeural"
    },
    {
        "locale": "ur-PK",
        "title": "اردو",
        "englishTitle": "Urdu (Pakistan)",
        "llmLangName": "",
        "langCode": "ur",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "",
        "azureTTSMale": ""
    },
    {
        "locale": "uz-UZ",
        "title": "Oʻzbek (lotin, Oʻzbekiston)",
        "englishTitle": "Uzbek (Latin, Uzbekistan)",
        "llmLangName": "",
        "langCode": "uz",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "uz-UZ-MadinaNeural",
        "azureTTSMale": "uz-UZ-SardorNeural"
    },
    {
        "locale": "vi-VN",
        "title": "Tieng viet",
        "englishTitle": "Vietnamese (Vietnam)",
        "llmLangName": "",
        "langCode": "vi",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "vi-VN-HoaiMyNeural",
        "azureTTSMale": "vi-VN-NamMinhNeural"
    },
    {
        "locale": "wuu-CN",
        "title": "吴语",
        "englishTitle": "Chinese (Wu, Simplified)",
        "llmLangName": "",
        "langCode": "wuu",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "wuu-CN-XiaotongNeural",
        "azureTTSMale": "wuu-CN-YunzheNeural"
    },
    {
        "locale": "yue-CN",
        "title": "粤语",
        "englishTitle": "Chinese (Cantonese, Simplified)",
        "llmLangName": "",
        "langCode": "yue",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "yue-CN-XiaoMinNeural",
        "azureTTSMale": "yue-CN-YunSongNeural"
    },
    {
        "locale": "zh-CN",
        "title": "简体中文",
        "englishTitle": "Chinese (Mandarin, Simplified)",
        "llmLangName": "Simplified Chinese",
        "langCode": "zh-Hans",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "zh-CN-XiaoxiaoNeural",
        "azureTTSMale": "zh-CN-YunxiNeural"
    },
    {
        "locale": "zh-HK",
        "title": "繁體中文 (廣東話)",
        "englishTitle": "Chinese (Cantonese, Traditional)",
        "llmLangName": "Cantonese",
        "langCode": "zh-Hant",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "zh-HK-HiuMaanNeural",
        "azureTTSMale": "zh-HK-WanLungNeural"
    },
    {
        "locale": "zh-TW",
        "title": "繁體中文",
        "englishTitle": "Chinese (Taiwanese Mandarin, Traditional)",
        "llmLangName": "Traditional Chinese",
        "langCode": "zh-Hant",
        "isBeta": false,
        "isMajor": true,
        "supportAzureSTT": true,
        "supportAzurePhraseList": true,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "zh-TW-HsiaoChenNeural",
        "azureTTSMale": "zh-TW-YunJheNeural"
    },
    {
        "locale": "zu-ZA",
        "title": "isiZulu",
        "englishTitle": "Zulu (South Africa)",
        "llmLangName": "",
        "langCode": "zu",
        "isBeta": false,
        "isMajor": false,
        "supportAzureSTT": true,
        "supportAzurePhraseList": false,
        "supportAzureLangIdentify": true,
        "supportAzureTranslation": false,
        "supportInstantTranslate": true,
        "azureTTSFemale": "zu-ZA-ThandoNeural",
        "azureTTSMale": "zu-ZA-ThembaNeural"
    }
]
